// Device enumeration, selection, persistence (F-CALL-3, F-LOB-1 groundwork).
// Storage is injected (SPEC §9.1: no DOM assumptions beyond WebRTC/WebCrypto);
// the web app passes localStorage, tests pass a stub. Key prefix per SPEC §3.2.

import { Room } from 'livekit-client';

export const DEVICE_PREFS_KEY = 'bz-device-prefs';

export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
}

export type DevicePrefs = Partial<Record<MediaDeviceKind, string>>;

export class DeviceManager {
  constructor(private storage: StorageLike) {}

  loadPrefs(): DevicePrefs {
    try {
      const raw = this.storage.getItem(DEVICE_PREFS_KEY);
      return raw ? (JSON.parse(raw) as DevicePrefs) : {};
    } catch {
      return {};
    }
  }

  savePref(kind: MediaDeviceKind, deviceId: string): void {
    const prefs = this.loadPrefs();
    prefs[kind] = deviceId;
    this.storage.setItem(DEVICE_PREFS_KEY, JSON.stringify(prefs));
  }

  /** Enumerate devices of a kind (labels require a prior permission grant). */
  async list(kind: MediaDeviceKind): Promise<MediaDeviceInfo[]> {
    return Room.getLocalDevices(kind, false);
  }

  /** The persisted device if it is still plugged in, else undefined. */
  async preferredAvailable(kind: MediaDeviceKind): Promise<string | undefined> {
    const wanted = this.loadPrefs()[kind];
    if (!wanted) return undefined;
    const devices = await this.list(kind);
    return devices.some((d) => d.deviceId === wanted) ? wanted : undefined;
  }
}
